module.exports = {"id":"171378","name":"Paul Aguilar","rating":"76","photo":"./data/images/photos/4/171378.png","club":{"name":"América","logo":"./data/images/clubs/America.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PaulAguilar0.json
// module id = 3389
// module chunks = 0